import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getResearchSpaceStatus } from "../../../api/knowledgeData/releasesApi";
import { useLoad } from "../../../shared/loading/useLoad";
import LoadStatus from "../../../ui/feedback/LoadStatus";
import Section from "../../../ui/forms/Section";
import DefinitionListItem from "../../../ui/layout/DefinitionListItem";

/**
 * Administration → ResearchSpace (F5, F10; knowledge-data.md K-13): the installation's one
 * ResearchSpace and how it runs. The connection is the installation's configuration
 * (`[data.researchspace]`); each project switches publishing on in its rules.
 */
export default function ResearchSpaceAdministrationPage() {
  const { t } = useTranslation();
  const load = useCallback((signal: AbortSignal) => getResearchSpaceStatus(signal), []);
  const researchSpace = useLoad(load);
  if (researchSpace.state.status !== "loaded") {
    return <LoadStatus state={researchSpace.state} loadingLabel={t("common.loading")} onRetry={researchSpace.reload} />;
  }
  const { available, status } = researchSpace.state.value;
  return (
    <Section title={t("data.researchSpace.administration.title")} hint={t("data.researchSpace.administration.hint")}>
      <dl className="text-sm">
        <DefinitionListItem term={t("data.researchSpace.administration.connection")}>
          {available ? t("data.researchSpace.administration.connected") : t("data.release.noResearchSpace")}
        </DefinitionListItem>
        {status !== null ? (
          <DefinitionListItem term={t("data.researchSpace.administration.running")}>{t(`data.researchSpace.runtime.${status}`)}</DefinitionListItem>
        ) : null}
      </dl>
    </Section>
  );
}
